export const errorMessage = {
  color: "#E33939",
  fontSize: 13,
  fontWeight: 500,
  display: "block",
  marginTop: 12,
};

export const forgetPasswordContainer = {
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  marginTop: 12,
  textAlign: "right",
} as const;

export const forgetPassword = {
  color: "#0097ff",
  fontWeight: 600,
  fontSize: 14,
};

export const subtitleContainer = {
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "32px",
  textAlign: "center",
} as const;

export const subtitle1 = {
  color: "#14213D",
  fontSize: "1.75rem",
  fontWeight: 700,
  letterSpacing: "-0.01em",
};

export const subtitle2 = {
  fontSize: "0.95rem",
  fontWeight: 500,
  letterSpacing: "0.1px",
  color: "#5B6472",
  marginTop: 8,
  display: "block",
};

export const content = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  maxWidth: 550,
  padding: "0 24px",
  [`@media (max-width: 768px)`]: {
    flex: "unset",
    maxWidth: "100%",
    padding: "10px",
    minHeight: "100vh",
    display: "flex",
  },
};

export const logo = {
  marginBottom: "32px",
  width: "60%",
};
